/**
 * Canvas-specific context types. These are set via the shared
 * useContextDrawer().setContext() — there is only one context
 * manager for the entire drawer.
 */

export const CANVAS_CONTEXT_TYPE = 'canvas_node' as const

export type CanvasNodeKind = 'source' | 'filter' | 'prospect' | 'action'

export interface CanvasNodeContext {
  type: typeof CANVAS_CONTEXT_TYPE
  playId: string
  pipelineId: string | null
  nodeKind: CanvasNodeKind
  nodeIndex: number
  nodeType: string
  nodeLabel: string
  /** Backend source id — set when nodeKind === 'source', so run history
   *  can be scoped to the specific Find block selected (a play can have
   *  several, each running independently). */
  sourceId?: string | null
  /** Backend SalesPlayAction id — set when nodeKind === 'action', so the
   *  needs-attention tab can be scoped to this action's ledger rows. */
  actionId?: string | null
  /** 'run' shows run history; 'edit' (default) shows config editors. */
  canvasMode?: 'run' | 'edit'
  /** Sub-tab to preselect on open, for action nodes with their own tab bar
   *  (e.g. jumping straight to Needs Attention from the footer pill). */
  initialSubTab?: string | null
}
